<template>
  <v-container id="settings">
    <MaterialCard
      elevation="0"
      color="primary"
      :title="this.$t('title.account_settings')"
    >
      <v-tabs
        v-model="tab"
        grow
        color="primary"
        center-active
        show-arrows
        icons-and-text
        class="pb-5"
      >
        <v-tab v-for="item in tabItems" :key="item.key">
          {{ $t(item.translation) }}
          <v-icon>{{ item.icon }}</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row class="pa-5">
            <v-col lg="8" cols="12">
              <v-form spellcheck="false" v-model="formValid" ref="profileform">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :value="$store.state.user.email"
                      :label="$t('label.email')"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <template v-if="!fieldEqualsDisplay('full_name', 'hidden')">
                    <v-col
                      v-for="field in possibleNameFields"
                      :key="field.id"
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="models[field.id]"
                        :rules="
                          fieldEqualsDisplay('full_name', 'required')
                            ? rules[field.id]
                            : []
                        "
                        type="text"
                        :label="$t(field.label)"
                        validate-on-blur
                        required
                      >
                        <template
                          v-if="fieldEqualsDisplay('full_name', 'required')"
                          #label
                        >
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t(field.label) }}
                        </template>
                      </v-text-field></v-col
                    >
                  </template>
                  <v-col
                    v-for="field in visibleTextFields"
                    :key="field.id"
                    cols="12"
                  >
                    <v-text-field
                      v-model="models[field.id]"
                      :rules="
                        fieldEqualsDisplay(field.id, 'required')
                          ? rules[field.id]
                          : []
                      "
                      :type="field.type"
                      :label="$t(field.label)"
                      validate-on-blur
                      required
                      :data-id="field.id"
                      :error-messages="
                        possibleTextFields[field.id].errorMessage
                      "
                      @input="possibleTextFields[field.id].errorMessage = ''"
                      :error="possibleTextFields[field.id].errorMessage !== ''"
                      @keyup="keyupEvent(field.id)"
                    >
                      <template
                        v-if="fieldEqualsDisplay(field.id, 'required')"
                        #label
                      >
                        <span class="red--text"><strong>* </strong></span
                        >{{ $t(field.label) }}
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col
                    v-if="
                      licensePlateField.id &&
                        !fieldEqualsDisplay(licensePlateField.id, 'hidden')
                    "
                    cols="12"
                  >
                    <LicensePlateField
                      v-model="models[licensePlateField.id]"
                      :label="licensePlateField.label"
                      :required="
                        fieldEqualsDisplay(licensePlateField.id, 'required')
                      "
                      @validating="
                        validating =>
                          (validatingLicensePlateLoader = validating)
                      "
                      excludeOwnCardSubscriptions
                    />
                  </v-col>
                  <template v-if="!fieldEqualsDisplay('address', 'hidden')">
                    <v-col
                      v-for="field in possibleAddressFields"
                      :key="field.id"
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="models[field.id]"
                        :rules="
                          fieldEqualsDisplay('address', 'required')
                            ? rules[field.id]
                            : []
                        "
                        type="text"
                        :label="$t(field.label)"
                        validate-on-blur
                        required
                      >
                        <template
                          v-if="fieldEqualsDisplay('address', 'required')"
                          #label
                        >
                          <span class="red--text"><strong>* </strong></span
                          >{{ $t(field.label) }}
                        </template>
                      </v-text-field></v-col
                    >
                  </template>
                  <v-col
                    v-if="
                      !fieldEqualsDisplay('invoice_email', 'hidden') ||
                        !fieldEqualsDisplay('expects_invoices', 'hidden')
                    "
                    cols="12"
                  >
                    <v-divider class="pa-3" />
                  </v-col>
                  <template
                    v-if="!fieldEqualsDisplay('invoice_email', 'hidden')"
                  >
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="models['invoice_email_recipient']"
                        :rules="
                          fieldEqualsDisplay('invoice_email', 'required')
                            ? rules['invoice_email_recipient']
                            : rules['email_validation']
                        "
                        type="text"
                        :label="$t('label.invoice_email_recipient')"
                        validate-on-blur
                        required
                      >
                        <template
                          v-if="fieldEqualsDisplay('invoice_email', 'required')"
                          #label
                        >
                          <span class="red--text"><strong>* </strong></span>
                          {{ $t("label.invoice_email_recipient") }}
                        </template>
                      </v-text-field>
                    </v-col>
                  </template>
                  <template
                    v-if="!fieldEqualsDisplay('expects_invoices', 'hidden')"
                  >
                    <v-col cols="12" md="6">
                      <v-checkbox
                        v-model="models['expects_invoices']"
                        :rules="
                          fieldEqualsDisplay('expects_invoices', 'required')
                            ? rules['expects_invoices']
                            : []
                        "
                        :label="$t('label.expects_invoices')"
                        validate-on-blur
                        required
                      >
                        <template
                          v-if="
                            fieldEqualsDisplay('expects_invoices', 'required')
                          "
                          #label
                        >
                          <span class="red--text"><strong>* </strong></span>
                          {{ $t("label.expects_invoices") }}
                        </template>
                      </v-checkbox>
                    </v-col>
                  </template>
                  <v-col v-if="$store.state.user.active_mandate" cols="6">
                    <v-text-field
                      :value="$store.state.user.partial_iban"
                      :label="$t('label.partial_iban')"
                      disabled
                    >
                      <template #append-outer>
                        <v-tooltip bottom>
                          <template #activator="{ on, attrs }">
                            <v-btn
                              text
                              small
                              v-bind="attrs"
                              v-on="on"
                              :aria-label="$t('label.change_iban')"
                              :title="$t('label.change_iban')"
                              @click="changeBankAccountDialog = true"
                            >
                              <v-icon>
                                mdi-pencil
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("label.change_iban") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <template
                    v-if="
                      !fieldEqualsDisplay('b2b', 'hidden') &&
                        $store.state.user.is_b2b_customer
                    "
                  >
                    <v-col cols="12">
                      <v-divider class="pa-3" />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="models['company_name']"
                        :rules="[v => !!v || $t('rules.b2b_field_required')]"
                        type="text"
                        validate-on-blur
                        required
                      >
                        <template #label>
                          <span class="red--text"><strong>* </strong></span>
                          {{ $t("label.company_name") }}
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="models['commercial_number']"
                        :rules="[v => !!v || $t('rules.b2b_field_required')]"
                        type="text"
                        validate-on-blur
                        required
                      >
                        <template #label>
                          <span class="red--text"><strong>* </strong></span>
                          {{ $t("label.commercial_number") }}
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="models['vat_number']"
                        :rules="rules['vat_number']"
                        type="text"
                        validate-on-blur
                        required
                      >
                        <template #label>
                          <span class="red--text"><strong>* </strong></span>
                          {{ $t("label.vat_number") }}
                        </template>
                      </v-text-field>
                    </v-col>
                  </template>
                </v-row>
                <v-divider class="pa-3" />
                <v-row>
                  <v-col
                    v-if="!fieldEqualsDisplay(possibleGenderField.id, 'hidden')"
                  >
                    <p>{{ $t("label.gender") }}</p>
                    <v-radio-group
                      v-model="models.gender"
                      row
                      :rules="
                        fieldEqualsDisplay(possibleGenderField.id, 'required')
                          ? rules[possibleGenderField.id]
                          : []
                      "
                    >
                      <v-radio
                        v-for="choice in possibleGenderField.choices"
                        :key="choice.value"
                        :value="choice.value"
                        :label="$t(choice.label)"
                        color="primary"
                      ></v-radio>
                      <template
                        v-if="
                          fieldEqualsDisplay(possibleGenderField.id, 'required')
                        "
                        #prepend
                      >
                        <span class="red--text"><strong>* </strong></span>
                      </template>
                    </v-radio-group>
                    <v-divider class="pa-3" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <p>{{ $t("label.site_language") }}</p>
                    <v-radio-group v-model="models['site_language']" row>
                      <v-radio
                        v-for="choice in possibleLanguages.choices"
                        :key="choice.value"
                        :value="choice.value"
                        :label="$t(choice.label)"
                        color="primary"
                      >
                      </v-radio>
                    </v-radio-group>
                    <v-divider class="pa-3" />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    v-if="!fieldEqualsDisplay(possibleDateField.id, 'hidden')"
                  >
                    <v-alert dense text type="info">
                      {{ editBirthDateMessage }}
                    </v-alert>
                    <v-text-field
                      :disabled="!editBirthDate"
                      v-model="models[possibleDateField.id]"
                      v-mask="possibleDateField.mask"
                      placeholder="DD-MM-YYYY"
                      :rules="
                        fieldEqualsDisplay(possibleDateField.id, 'required')
                          ? rules[possibleDateField.id]
                          : rules['optional_birth_date']
                      "
                      :label="possibleDateField.label"
                      validate-on-blur
                    >
                      <template #label>
                        <span
                          v-if="
                            fieldEqualsDisplay(possibleDateField.id, 'required')
                          "
                          class="red--text"
                          ><strong>* </strong></span
                        >
                        {{ $t(possibleDateField.label) }}
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-divider v-if="visibleCheckFields.length > 0" class="pa-3" />
                <v-row>
                  <v-col
                    v-for="field in visibleCheckFields"
                    :key="field.id"
                    cols="12"
                    md="6"
                  >
                    <v-checkbox
                      v-model="models[field.id]"
                      color="primary"
                      validate-on-blur
                      :error="
                        fieldEqualsDisplay(field.id, 'required') &&
                          (models[field.id] === false ||
                            models[field.id] === null)
                      "
                      required
                    >
                      <template #label>
                        {{ $t(field.label)
                        }}<span
                          v-if="fieldEqualsDisplay(field.id, 'required')"
                          class="red--text"
                          ><strong>* </strong></span
                        >
                      </template></v-checkbox
                    >
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
            <v-col class="text-center hidden-md-and-down" align-self="center">
              <span
                v-html="$store.state.config.template_settings.profile_sidebar"
              ></span>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col class="pa-5">
              <v-btn
                @click="updateUser"
                class="no-text-transform display-1"
                color="primary"
                :loading="busyUpdating"
                :disabled="!formValid"
              >
                {{ $t("button.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item
          v-if="$store.state.config.template_settings.show_anonymous_cards"
        >
          <ConfigureBarcodes></ConfigureBarcodes>
        </v-tab-item>
        <v-tab-item>
          <div class="pa-5">
            <v-row>
              <v-col md="8" cols="12">
                <div class="display-2 mb-4">
                  {{ $t("message.deactivate_account_header") }}
                </div>
                <div class="mb-8">
                  {{ $t("message.deactivate_account") }}
                </div>
                <v-btn
                  @click="deleteAccountDialog = true"
                  text
                  class="red--text px-0 no-text-transform font-weight-bold"
                  >{{ $t("button.delete_account") }}</v-btn
                >
              </v-col>
              <v-col class="text-center hidden-md-and-down" align-self="center">
                <v-icon size="150">mdi-account-remove</v-icon>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </MaterialCard>
    <v-dialog v-model="facebookConnectDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          $t("title.facebook_connect_modal")
        }}</v-card-title>
        <v-card-text>{{ $t("message.facebook_connect_modal") }}</v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions class="justify-center">
          <v-btn color="green darken-1" text @click="agreeFacebookOverride">{{
            $t("button.yes")
          }}</v-btn>
          <v-btn color="red darken-1" text @click="disagreeFacebookOverride">{{
            $t("button.no")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteAccountDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          $t("message.deactivate_account_header")
        }}</v-card-title>
        <v-card-text>{{ $t("message.deactivate_account") }}</v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions class="justify-center">
          <v-btn color="green darken-1" text @click="stopAccountDeletion">{{
            $t("button.no")
          }}</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="deleteAccount"
            :loading="deleteLoading"
            >{{ $t("button.yes") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="changeBankAccountDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">
          {{ $t("label.change_iban") }}
        </v-card-title>
        <v-card-text>{{ $t("message.change_bank_account") }}</v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions class="justify-center">
          <v-btn
            color="red darken-1"
            text
            @click="changeBankAccountDialog = false"
            :disabled="changeBankAccountLoading"
          >
            {{ $t("button.no") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="handleChangeBankAccount"
            :loading="changeBankAccountLoading"
          >
            {{ $t("button.yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import MaterialCard from "@/components/views/MaterialCard";
import { mask } from "vue-the-mask";
import ConfigureBarcodes from "./components/ConfigureBarcodes";
import { settings } from "@/mixins/settings";
import LicensePlateField from "@/components/fields/LicensePlateField.vue";

export default {
  name: "Settings",
  components: { LicensePlateField, ConfigureBarcodes, MaterialCard },
  directives: {
    mask
  },
  mixins: [settings]
};
</script>

<style scoped>
.fb-signin-button {
  border-radius: 3px;
  background-color: #4267b2 !important;
}
</style>
